/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.regexp.replace";
import _classCallCheck from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/classCallCheck";
import _inherits from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/inherits";
import _possibleConstructorReturn from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/possibleConstructorReturn";
import _getPrototypeOf from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/getPrototypeOf";
import _wrapNativeSuper from "/artifacts/APP/AppSwitchPowerActivityH5/AppSwitchPowerActivityH5_DEV_group1_dev_20200310201907/node_modules/@babel/runtime/helpers/builtin/es6/wrapNativeSuper";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import store from '@/store';
import route from '../router';
var HttpErrorList = {
  404: '请求地址错误或后端接口未部署',
  403: '没有相关权限',
  401: '登录状态过期, 需要重新登录',
  500: '后端服务有未处理的错误',
  502: '后端接口无响应',
  504: '请求超时, 可能是网络问题, 请稍后重试'
};

var HttpBizError =
/*#__PURE__*/
function (_Error) {
  function HttpBizError(message, request, response) {
    var _this;

    _classCallCheck(this, HttpBizError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(HttpBizError).call(this, message));
    _this.name = 'HttpBizError';
    _this.request = request;
    _this.response = response;
    _this.message = message;
    return _this;
  }

  _inherits(HttpBizError, _Error);

  return HttpBizError;
}(_wrapNativeSuper(Error));

var HttpNetworkError =
/*#__PURE__*/
function (_Error2) {
  function HttpNetworkError(message) {
    var _this2;

    _classCallCheck(this, HttpNetworkError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(HttpNetworkError).call(this, message));
    _this2.name = 'HttpNetworkError';
    _this2.message = message;
    return _this2;
  }

  _inherits(HttpNetworkError, _Error2);

  return HttpNetworkError;
}(_wrapNativeSuper(Error));

function Catcher(response, isHttpError) {
  var loginName = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'login';

  if (!response) {
    throw new HttpNetworkError('网络请求错误');
  }

  if (isHttpError) {
    var code = response.code;
    var baseMessage = '网络请求错误'; // eslint-disable-next-line no-console

    console.error(HttpErrorList[code]);
    throw new HttpNetworkError(baseMessage);
  } else {
    var config = response.config,
        data = response.data,
        request = response.request;

    var _baseMessage = data.msg || HttpErrorList[data.code] || '后端接口报错';

    if (data.code === 103) {
      store.dispatch('logout'); // 此处跳转登录页面

      route.replace({
        name: loginName,
        query: route.currentRoute.query
      });
      _baseMessage = '请先登录';
    }

    if (!config.noGlobalMessage) {
      // eslint-disable-next-line no-console
      console.error(_baseMessage);
    }

    throw new HttpBizError(_baseMessage, request, data);
  }
}

export default Catcher;